module.exports = __webpack_public_path__ + "static/mobile-ui-kit-cover-6ba9f65a7ad92a5e9b720c1e93c0e477.png";